import { OrderingInitialState } from '@reducers/ordering/types';

export const removeFreeItem = (state: OrderingInitialState): OrderingInitialState => {
  const menuItems = state.orderState.menus.filter((menu) => !menu.isFreeItem);

  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: menuItems,
    },
  };
};
